import './PlaceHeader.css';
import type { ComponentChildren } from 'preact';

export interface PlaceHeaderProps {
  /** Nome do lugar (o `h2#place-title`, nome acessível do cartão, §15.4.2). */
  title: string;
  /** Subtítulo pronto ("34,5% das seções · 34,1 milhões de eleitores"); ausente = sem a linha. */
  sub?: string | null;
  /** Selo de 40 px (`StateSeal`, globo ou `UfTile`, §8.1); decorativo. */
  seal?: ComponentChildren;
  /** Botões do canto (`UfNavButtons`): 3 na UF, 1 nos demais, 0 na TV. Reserva o espaço à direita (§8.1). */
  buttons?: 0 | 1 | 3;
}

/**
 * Cabeçalho do cartão de lugar (§8.1): grade `40px 1fr` com o selo e o título serif de até 2 linhas; o `h2` tem
 * `id="place-title"` e `tabindex="-1"`, alvo do foco ao abrir ou trocar de lugar pelo teclado (§5.9, §15.2.2).
 */
export function PlaceHeader({ title, sub = null, seal, buttons = 0 }: PlaceHeaderProps) {
  return (
    <div class="place-header" data-testid="place-header" data-buttons={String(buttons)}>
      <span class="place-header__seal">{seal}</span>
      <div class="place-header__text">
        <h2 id="place-title" class="place-header__title" tabIndex={-1}>
          {title}
        </h2>
        {sub ? <p class="place-header__sub">{sub}</p> : null}
      </div>
    </div>
  );
}
